import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInventoryItems(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('inventory/item', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteInventoryItems(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`inventory/item/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
